import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type { PublicEVBServiceControlResponse } from '@/features/EVBService/types';

export class EVBHttpService extends HttpService {
  loadControlInformation(): HttpClientResponse<PublicEVBServiceControlResponse> {
    return this.httpClient.get('eVB/requestEvbControlInformation');
  }
}
